import React, { Component } from 'react';
import Joi from 'joi-browser';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import './style.scss';

class Form extends Component {
    state = {
        name: '',
        phone: '',
        email: '',
        area: '',
        description: '',
        error: {}
    }

    schema = {
        email: Joi.string().email({ minDomainAtoms: 2 }).required().error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "string.email":
                        err.message = 'email mast be A Valid Email';
                        break;
                    default:
                        err.message = 'email can not be empity';
                        break;
                }
            });
            return errors;
        }),
        phone: Joi.string().required().error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    default:
                        err.message = 'phone can not be Empity';
                        break;
                }
            });
            return errors;
        }),
        name: Joi.string().required().error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    default:
                        err.message = 'name can not be Empity';
                        break;
                }
            });
            return errors;
        }),
        description: Joi.string().required().error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    default:
                        err.message = 'description can not be Empity';
                        break;
                }
            });
            return errors;
        }),
        area: Joi.string(),
    }
    changeHandler = event => {
        const error = { ...this.state.error };
        const errorMassage = this.validationProperty(event);
        if (errorMassage) {
            error[event.target.name] = errorMassage;
        } else {
            delete error[event.target.name];
        }
        this.setState({
            [event.target.name]: event.target.value,
            error
        })
    };
    handleChange = (value) => {
        this.setState({
            country: value
        })
    };

    validationProperty = event => {
        const Obj = { [event.target.name]: event.target.value };
        const schema = { [event.target.name]: this.schema[event.target.name] }
        const { error } = Joi.validate(Obj, schema);
        return error ? error.details[0].message : null
    };

    validate = () => {
        const options = { abortEarly: false }
        const form = {
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            description: this.state.description,
        }
        const { error } = Joi.validate(form, this.schema, options)
        if (!error) return null;

        const errors = {};
        for (let item of error.details) errors[item.path[0]] = item.message
        return errors;
    };

    submitHandler = async event => {
        event.preventDefault();
        const url = 'https://gtu9t93k5h.execute-api.us-east-1.amazonaws.com/default/vasili-email';
        const error = this.validate();

        if (error) {
            this.setState({
                error: error || {}
            });
        } else {
            try {
                await axios.post(url, this.state, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }});
                this.setState({
                    name: '',
                    phone: '',
                    email: '',
                    area: '',
                    description: '',
                });

                toast.success('Thank you for your submission. We will be in touch soon.');
            } catch (err) {
                toast.error('There was a problem submitting your request. Please try again.');
            }
        }
    }

    render() {
        const options = [
            { level: 'Select Area', value: '' },
            { level: 'Family Law', value: 'family law' },
            { level: 'Civil Litigation', value: 'civil litigation' },
            { level: 'Bankruptcy', value: 'bankruptcy' },
            { level: 'Business Law', value: 'business law' },
            { level: 'Wills and Trusts', value: 'wills and trusts' },
            { level: 'Other', value: 'other' },
        ]

        return (
            <form onSubmit={this.submitHandler} className='contactForm'>
                <div className="row">
                    <div className="col-sm-6 col-12">
                        <div className="formInput">
                            <input
                                placeholder="Your Name"
                                value={this.state.name}
                                name="name"
                                onChange={this.changeHandler}
                                className="form-control"
                                type="text" />
                            {this.state.error.name && <p>{this.state.error.name}</p>}
                        </div>

                    </div>
                    <div className="col-sm-6 col-12">
                        <div className="formInput">
                            <input
                                placeholder="Phone"
                                value={this.state.phone}
                                name="phone"
                                onChange={this.changeHandler}
                                className="form-control"
                                type="phone" />
                            {this.state.error.phone && <p>{this.state.error.phone}</p>}
                        </div>
                    </div>
                    <div className="col-sm-6 col-12">
                        <div className="formInput">
                            <input
                                placeholder="Email"
                                value={this.state.email}
                                name="email"
                                onChange={this.changeHandler}
                                className="form-control"
                                type="email" />
                            {this.state.error.email && <p>{this.state.error.email}</p>}
                        </div>
                    </div>
                    <div className="col-sm-6 col-12">
                        <div className="formInput">
                            <select
                                value={this.state.area}
                                className="form-control"
                                onChange={this.changeHandler}
                                name="area">
                                {options.map(option => (
                                    <option
                                        key={option.value}
                                        value={option.value}
                                    >
                                        {option.level}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="formInput">
                            <textarea
                                className="form-control"
                                value={this.state.description}
                                onChange={this.changeHandler}
                                placeholder="Case Description..."
                                name="description" />
                            {this.state.error.description && <p>{this.state.error.description}</p>}
                        </div>
                    </div>
                    <div className="col-12">
                        <button type="submit">Submit</button>
                    </div>
                </div>
            </form>
        )
    }
}
export default Form